<template>
    <div>
        <top-navbar :breadcrumb="breadcrumb"></top-navbar>

        <div class="container-fluid mt--6">
            <div class="row">
                <div class="col-12">
                    <grids-clear></grids-clear>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import GridsClear from './competencies/GridsClear';

    export default {

        components: {
            GridsClear
        },

        computed: {

            breadcrumb() {
                return [
                    {
                        name: this.$t('common.competency-grids'),
                        route: '/socrates/ui/training/competency-grids'
                    },
                    {
                        name: this.$t('common.outdated'),
                    },
                ]
            }
        },
    }
</script>
